import { getLocale } from '../locale';
export const getStoreLocatorBaseURL = () => {
    return process.env.STORE_LOCATOR_API_URL || 'https://api.storelocator.hmgroup.tech';
};
export const getStoreLocatorURL = (locale) => {
    const base = getStoreLocatorBaseURL();
    return `${base}/v2/brand/hm/stores/locale/${locale || getLocale()}/stores?storecodes=`;
};
//# sourceMappingURL=getStoreLocatorURL.js.map